// Signed Registration settings for unattended hall browsers.

export const ONSITE_IDLE_HOME_DEFAULT_MS = 120_000;
export const ONSITE_IDLE_HOME_MIN_MS = 30_000;
export const ONSITE_IDLE_HOME_MAX_MS = 10 * 60_000;
export const ONSITE_CREW_RESET_DEFAULT = true;

export type OnsiteResetSettings = {
  readonly idleHomeMs: number;
  readonly crewResetEnabled: boolean;
};

export function onsiteIdleHomeMsIsValid(value: unknown): value is number {
  return (
    typeof value === "number" &&
    Number.isInteger(value) &&
    value >= ONSITE_IDLE_HOME_MIN_MS &&
    value <= ONSITE_IDLE_HOME_MAX_MS
  );
}

/** Old or malformed bundles retain the current safe behavior. */
export function onsiteResetFromBundle(bundle: unknown): OnsiteResetSettings {
  if (bundle === null || typeof bundle !== "object" || Array.isArray(bundle)) {
    return {
      idleHomeMs: ONSITE_IDLE_HOME_DEFAULT_MS,
      crewResetEnabled: ONSITE_CREW_RESET_DEFAULT,
    };
  }
  const body = bundle as Record<string, unknown>;
  return {
    idleHomeMs: onsiteIdleHomeMsIsValid(body["onsite_idle_home_ms"])
      ? body["onsite_idle_home_ms"]
      : ONSITE_IDLE_HOME_DEFAULT_MS,
    crewResetEnabled:
      typeof body["onsite_crew_reset_enabled"] === "boolean"
        ? body["onsite_crew_reset_enabled"]
        : ONSITE_CREW_RESET_DEFAULT,
  };
}
